import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "../SignupPages/SignupCommon.css";

const IntakeFormPage3: React.FC = () => {
  const [gender, setGender] = useState<string>("");
  const [isPlanningBaby, setIsPlanningBaby] = useState<string>("");
  const navigate = useNavigate();

  const handleGenderOptionClick = (option: string) => {
    setGender(option);
    if (option === "Male") {
      setIsPlanningBaby("");
    }
  };

  const handleBabyPlanningOptionClick = (option: string) => {
    setIsPlanningBaby(option);
  };

  useEffect(() => {
    const completeIntakeStep1 = localStorage.getItem("complete-intake-step1");
    if (completeIntakeStep1) {
      navigate("/complete-intake/step-1", { replace: true });
    }
  }, []);

  useEffect(() => {
    const savedGender = localStorage.getItem("gender");
    const savedIsPlanningBaby = localStorage.getItem("isPlanningBaby");

    if (savedGender) {
      const parsedGender = JSON.parse(savedGender);
      setGender(parsedGender.value);
    }

    if (savedIsPlanningBaby) {
      const parsedIsPlanningBaby = JSON.parse(savedIsPlanningBaby);
      setIsPlanningBaby(parsedIsPlanningBaby.value);
    }
  }, []);

  const handleNext = () => {
    if (gender) {
      localStorage.setItem(
        "gender",
        JSON.stringify({ key: "gender", value: gender, id: 18026054 })
      );
    }
    if (isPlanningBaby) {
      localStorage.setItem(
        "isPlanningBaby",
        JSON.stringify({
          key: "isPlanningBaby",
          value: isPlanningBaby,
          id: 18026056,
        })
      );
    }

    const shouldDisqualify =
      gender === "Female" && isPlanningBaby !== "None of the Following";

    if (shouldDisqualify) {
      navigate("/complete-intake/disqualified");
    } else {
      navigate("/complete-intake/step-2");
    }
    localStorage.setItem("complete-intake-step1", "true");
  };

  const genderOptions = ["Male", "Female"];
  const optionsForBabyPlanning = [
    "None of the Following",
    "Currently or possibly pregnant, or actively trying to become pregnant",
    "Breastfeeding or bottle feeding with breastmilk",
  ];

  const styles = {
    optionsStacked: {
      display: "flex",
      flexDirection: "column" as const,
      gap: "15px",
      marginBottom: "20px",
      width: "100%",
      marginTop: "41px",
    },
    optionLabel: {
      fontSize: "18px",
      padding: "15px",
      cursor: "pointer",
      border: "1px solid #96C6DA",
      borderRadius: "10px",
      transition: "background-color 0.3s ease",
      width: "100%",
      textAlign: "center" as const,
      backgroundColor: "white",
    },
    optionLabelSelected: {
      backgroundColor: "#0C3972",
      color: "white",
    },
  };

  const step = 1;
  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={18} step={step} />
        <div className="signup-content">
          <p className="signup-intro">What is your sex assigned at birth?</p>
          <div className="optionsLeftRight">
            {genderOptions.map((option) => (
              <label
                key={option}
                className={`optionLabel ${
                  gender === option ? "optionLabelSelected" : ""
                }`}
                onClick={() => handleGenderOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          {gender === "Female" && (
            <>
              <p className="signup-question" style={{ marginTop: "72px" }}>
                Are you currently or planning for any of the following?
              </p>
              <div style={styles.optionsStacked}>
                {optionsForBabyPlanning.map((option) => (
                  <label
                    key={option}
                    onClick={() => handleBabyPlanningOptionClick(option)}
                    className={`otherOptionLabel ${
                      isPlanningBaby === option ? "optionLabelSelected" : ""
                    }`}
                  >
                    {option}
                  </label>
                ))}
              </div>
            </>
          )}
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!gender || (gender === "Female" && !isPlanningBaby)}
          >
            Next →
          </button>
          {gender === "Female" && (
            <p className="femaleDisclaimer">
              Please note that we strongly recommend that you use an effective
              method of contraception during treatment with a GLP-1 medication
              and for at least 2 months thereafter. For those taking Zepbound or
              Mounjaro (tirzepatide), we recommend switching to a non-oral
              contraceptive method or adding a barrier method of contraception
              for four weeks after initiation and for four weeks after each dose
              escalation.
            </p>
          )}
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage3;
